<div class="s09-modal-backdrop" (click)="close.emit()">
  <div class="s09-modal" (click)="$event.stopPropagation()">
    <div class="s09-modal-h">
      <div>
        <div style="font-size:17px;font-weight:600">{{ startFrom === 'clone' ? 'Clone a workflow' : 'Create New Workflow' }}</div>
        <div style="font-size:12px;color:var(--s09-muted);margin-top:3px">
          {{ startFrom === 'clone'
            ? 'The steps, trigger, and case type are copied. Give the copy a new code and name. It opens as a draft.'
            : 'Enter the basics only. The canvas starts empty — add steps from the library after create.' }}
        </div>
      </div>
      <button type="button" class="s09-icon-btn" (click)="close.emit()" aria-label="Close">×</button>
    </div>

    <div class="s09-modal-b">
      <div class="s09-field">
        <label>Start from</label>
        <div class="s09-chip-row">
          <button type="button" class="s09-choice" [class.on]="startFrom==='blank'" (click)="useBlank()">Blank canvas</button>
          <button type="button" class="s09-choice" [class.on]="startFrom==='clone'" [disabled]="!definitions.length" (click)="useClone()">Clone existing</button>
        </div>
        <select *ngIf="startFrom==='clone'" [ngModel]="draft.sourceWfDefId" (ngModelChange)="useClone($event)">
          <option *ngFor="let d of definitions" [ngValue]="d.wf_def_id">{{ d.wf_name }}</option>
        </select>
      </div>

      <div class="s09-field" *ngIf="startFrom==='blank'">
        <label>Who it is for <span style="color:var(--s09-danger)">*</span></label>
        <div style="display:grid;grid-template-columns:1fr 1fr 1fr;gap:8px">
          <button type="button" class="s09-choice" [class.on]="draft.group==='patient'" (click)="pickGroup('patient')">Patient</button>
          <button type="button" class="s09-choice" [class.on]="draft.group==='account'" (click)="pickGroup('account')">Account / office</button>
          <button type="button" class="s09-choice" [class.on]="draft.group==='shared'" (click)="pickGroup('shared')">Shared module</button>
        </div>
      </div>

      <div style="display:grid;grid-template-columns:120px 1fr;gap:10px">
        <div class="s09-field">
          <label>Code <span style="color:var(--s09-danger)">*</span></label>
          <input [(ngModel)]="draft.code" placeholder="e.g. MI" />
        </div>
        <div class="s09-field">
          <label>Workflow name <span style="color:var(--s09-danger)">*</span></label>
          <input [(ngModel)]="draft.name" placeholder="e.g. Missing info" />
        </div>
      </div>

      <ng-container *ngIf="startFrom==='blank'">
      <div class="s09-field">
        <label>Priority</label>
        <div class="s09-chip-row">
          <button type="button" class="s09-choice" [class.on]="draft.priority==='Low'" (click)="pickPrio('Low')">Low</button>
          <button type="button" class="s09-choice" [class.on]="draft.priority==='Medium'" (click)="pickPrio('Medium')">Medium</button>
          <button type="button" class="s09-choice" [class.on]="draft.priority==='High'" (click)="pickPrio('High')">High</button>
        </div>
      </div>

      <div class="s09-section-lbl">What starts it</div>

      <div class="s09-field">
        <label>Trigger type <span style="color:var(--s09-danger)">*</span></label>
        <div style="display:grid;grid-template-columns:repeat(4,minmax(0,1fr));gap:8px">
          <button type="button" class="s09-choice" style="height:42px;justify-content:flex-start;gap:8px;padding:0 10px"
            *ngFor="let id of triggerIds" [class.on]="draft.trigger===id" (click)="pickTrigger(id)">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9"
              stroke-linecap="round" stroke-linejoin="round"><path [attr.d]="trigPath(id)"></path></svg>
            {{ trigLabel(id) }}
          </button>
        </div>
        <span style="font-size:11px;color:var(--s09-muted)">{{ trigHint }}</span>
      </div>

      <div class="s09-field">
        <label>Signals</label>
        <div class="s09-code-chips" style="min-height:24px">
          <span *ngFor="let c of draft.codes" class="s09-code-chip on">
            {{ c }}
            <button type="button" class="s09-code-x" title="Remove" (click)="removeCode(c)">×</button>
          </span>
          <span *ngIf="!draft.codes.length" class="s09-field-hint">None selected yet.</span>
        </div>

        <div *ngIf="signalsLoading" style="font-size:12px;color:var(--s09-muted)">Loading signals…</div>
        <div *ngIf="!signalsLoading && signalsError" class="s09-err">{{ signalsError }}</div>

        <div *ngIf="!signalsLoading && signalGroups.length"
          style="border:1px solid var(--s09-border);border-radius:8px;padding:10px;max-height:200px;overflow:auto;background:#FBFCFE;display:flex;flex-direction:column;gap:10px">
          <div *ngFor="let g of signalGroups">
            <div style="font-size:10px;font-weight:600;letter-spacing:.06em;text-transform:uppercase;color:var(--s09-muted);margin-bottom:5px">
              {{ g.group_label }}
            </div>
            <div class="s09-code-chips">
              <button type="button" class="s09-code-chip"
                *ngFor="let s of g.signals" [class.on]="isCodeOn(s.signal_code)"
                [title]="signalTip(s)"
                [attr.aria-label]="signalTip(s)"
                (click)="toggleCode(s.signal_code)">{{ s.signal_code }}</button>
            </div>
          </div>
        </div>

        <div style="display:flex;gap:6px;margin-top:8px">
          <input [(ngModel)]="draft.sigOther" placeholder="Add a code not in the list (comma separated)"
            style="font-family:ui-monospace,Menlo,Consolas,monospace" />
          <button type="button" class="s09-btn" (click)="addOther()">Add</button>
        </div>
      </div>

      <div class="s09-field">
        <label>Condition / threshold <span style="font-weight:400;color:var(--s09-muted)">(optional)</span></label>
        <div *ngIf="conditionsLoading" style="font-size:12px;color:var(--s09-muted)">Loading conditions…</div>
        <div *ngIf="!conditionsLoading && conditionsHint" style="font-size:11px;color:var(--s09-muted);margin-bottom:6px">{{ conditionsHint }}</div>
        <div class="s09-chip-row" *ngIf="conditionsForTrigger.length">
          <button type="button" class="s09-choice" *ngFor="let c of conditionsForTrigger"
            [class.on]="draft.threshold===c.condition_label"
            (click)="pickCondition(c.condition_label)">{{ c.condition_label }}</button>
        </div>
        <input [(ngModel)]="draft.threshold" placeholder="Select above or type a custom condition" style="margin-top:8px" />
      </div>
      </ng-container>

      <div class="s09-err" *ngIf="err">{{ err }}</div>
    </div>

    <div class="s09-modal-f">
      <button type="button" class="s09-btn" (click)="close.emit()">Cancel</button>
      <button type="button" class="s09-btn primary" (click)="submit()">{{ startFrom === 'clone' ? 'Clone & open designer' : 'Create & open designer' }}</button>
    </div>
  </div>
</div>
